import { Box, Grid, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function HomeBanner(props) {
    var gridMargin = props.gridMargin
    const MapLink = props => <Link to="/signup" {...props} />
    return (
        <Grid container spacing={0} sx={{ margin: gridMargin }}>
            <Grid item xs={12} sm={12} md={7}>
                <Box sx={{ justifyContent: 'flex-start', textAlign: 'left', paddingTop: "64px"}}>
                    <Typography variant="h1" sx={{ fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem" } }}>Simplify your school redistricting process</Typography>
                    <Typography variant="subtitle1" color="#adaca8" sx={{ marginTop: "1.5rem", fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" } }}>
                        Quickly test and implement informed school boundary scenarios with Good Blocks’s interactive mapping interface, 
                        boundary suggestions tool, and custom evaluation metrics.
                    </Typography>
                    <Button
                    component={MapLink}
                    variant="contained"
                    disableElevation
                    color="secondary"
                    sx={{ marginTop: "1.65rem", color: "white" }}>
                        <Typography variant="h6">Schedule a demo</Typography>
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={5}>
            <Box
                    component="img"
                    sx={{
                        display: 'flex',
                        paddingTop: "48px",
                        height: "450px"
                    }}
                    alt="Person drawing school boundaries with large pencil."
                    src="https://sde-resources.s3.amazonaws.com/img/drawer.svg"
                />
            </Grid>
        </Grid>
    )
}